import React, { useCallback } from 'react';

import { Box } from '@mui/material';
import ModalCDS from '@sharedCR/coreDesignSystem/Modals/ModalCDS';
import { ModalSize } from '@sharedCR/coreDesignSystem/Modals/ModalCDS/ModalCDS.constants';
import PropTypes from 'prop-types';

import { PREVIEW_MODAL_ID } from '../../FormChangeHistory.constants';
import { PreviewPanesPropType } from '../../FormChangeHistory.propTypes';
import { modalBodyStyles } from '../../FormChangeHistory.styles';
import { FormChangeHistoryTestIds } from '../../FormChangeHistory.testIds';
import PagedTemplatePreview from '../PagedTemplatePreview';
import SampleDataNotice from '../SampleDataNotice';

/**
 * A template's two sides side by side, each filled with sample data and shown page by page; a Prism
 * template's changed parts are marked.
 */
const TemplatePreviewModal = ({
  auditId,
  isOpen,
  panes,
  templateKind,
  title,
  onClose,
  parts = null,
}) => {
  const renderBody = useCallback(
    () => (
      <Box sx={modalBodyStyles}>
        <SampleDataNotice />
        <PagedTemplatePreview
          auditId={auditId}
          panes={panes}
          parts={parts}
          templateKind={templateKind}
        />
      </Box>
    ),
    [auditId, panes, parts, templateKind],
  );

  return (
    <ModalCDS
      isRestyled
      afterCloseCallback={onClose}
      body={renderBody}
      dataTestId={FormChangeHistoryTestIds.PREVIEW_MODAL}
      header={title}
      id={PREVIEW_MODAL_ID}
      keepMounted={false}
      open={isOpen}
      size={ModalSize.FULL}
    />
  );
};

TemplatePreviewModal.propTypes = {
  auditId: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  panes: PreviewPanesPropType.isRequired,
  templateKind: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  parts: PropTypes.arrayOf(PropTypes.object),
};

export default TemplatePreviewModal;
